export default "__VITE_ASSET__DCXgF8fh__"